import './heroSection.scss'
import React from 'react'
import Button from '../../../../components/button/Button'
import { useHistory } from 'react-router-dom'

const ServicesHeroSection = () => {
  const history = useHistory()
  return (
    <div className="services__hero__section">
      <div className="services__hero__section__wrapper">
        <h1 className="services__hero__section__wrapper__heading primary__heading">
          We’ve got you covered.
        </h1>
        <p className="services__hero__section__wrapper__paragraph">
          Our customer experience experts are here to help your callers and
          visitors 24/7.{' '}
        </p>
        <Button
          onclick={() => history.push('/price-plan')}
          type="secondary"
          text="View Our Plans"
        />
      </div>
    </div>
  )
}

export default ServicesHeroSection
